"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconFactory_1 = require("../../utils/iconFactory");
// AEM-Name: ChevronLeftIcon
exports.ChevronLeftIcon = iconFactory_1.iconFactory({
    componentName: 'ChevronLeftIcon',
    viewBox: '0 0 24 24',
    title: 'ChevronLeftIcon',
    g: "<path id=\"chevronlefticon-a\" d=\"M18.3333333,19.4939759 L8.19047619,11.9759036 L18.3333333,4.45783133 L18.3333333,2 L6.76190476,10.5301205 C6.28571429,10.8674699 6,11.3975904 6,11.9759036 C6,12.5542169 6.28571429,13.0843373 6.76190476,13.4216867 L18.3333333,22 L18.3333333,19.4939759 Z\"/>",
    gThemed: { "ergo-one": { "viewBox": "0 0 24 24", "g": "<path id=\"chevronlefticon-a\" d=\"M18.3333333,19.4939759 L8.19047619,11.9759036 L18.3333333,4.45783133 L18.3333333,2 L6.76190476,10.5301205 C6.28571429,10.8674699 6,11.3975904 6,11.9759036 C6,12.5542169 6.28571429,13.0843373 6.76190476,13.4216867 L18.3333333,22 L18.3333333,19.4939759 Z\"/>" } }
});
exports.default = exports.ChevronLeftIcon;
//# sourceMappingURL=ChevronLeftIcon.js.map